'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponController = function () {
  function CouponController(CouponsDataProvider) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CouponController);
    this.CouponsDataProvider = CouponsDataProvider;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
    this.field = 'id';
    this.order_type = 'desc';
    this.col = 0;
    this.colTopDown = 0;
    this.getCoupons();
    this.checkboxes = [];
  }

  (0, _createClass3.default)(CouponController, [{
    key: 'getSortRecors',
    value: function getSortRecors(field, order_type, col, colTopDown) {
      this.field = field;
      this.order_type = order_type;
      this.col = col;
      this.colTopDown = colTopDown;
      this.getCoupons();
    }
  }, {
    key: 'getCoupons',
    value: function getCoupons() {
      var vm = this;
      var data = {};
      var searchData = {};
      searchData.name = vm.name;
      searchData.code = vm.code;
      searchData.type = vm.type;
      searchData.price_to = vm.price_to;
      searchData.price_from = vm.price_from;
      searchData.used_count = vm.used_count;
      searchData.status = vm.status;
      data.searchData = searchData;
      data.currentPage = vm.currentPage;
      data.pageLimit = vm.pageLimit;
      data.field = vm.field;
      data.order_type = vm.order_type;
      vm.CouponsDataProvider.getCoupons(data, searchData).then(function (result) {
        vm.coupons = result.data;
        vm.couponsTotal = result.total;
        vm.selectall = false;
      });
    }
  }, {
    key: 'changeStatus',
    value: function changeStatus() {
      if (!this.status_change) {
        return false;
      }
      if (this.checkboxes.length == 0) {
        alert('please select coupon first');
        return false;
      }
      var vm = this;
      var data = { 'status': vm.status_change, 'ids': vm.checkboxes };
      vm.CouponsDataProvider.updateCouponStatus(data).then(function (resp) {
        vm.pages = resp;
        vm.getCoupons();
        vm.checkboxes = [];
      });
    }
  }, {
    key: 'changeStatusSingle',
    value: function changeStatusSingle(status, id) {
      var data = { 'status': status };
      this.updateCoupon(data, id);
    }
  }, {
    key: 'updateCoupon',
    value: function updateCoupon(data, id) {
      var vm = this;
      vm.CouponsDataProvider.updateCoupon(data, id).then(function (resp) {
        vm.getCoupons();
      });
    }
  }, {
    key: 'removeCoupon',
    value: function removeCoupon(id) {
      if (confirm("Are you sure to delete!") !== true) {
        return false;
      }
      var vm = this;
      vm.CouponsDataProvider.removeCoupon(id).then(function (res) {
        vm.getCoupons();
      });
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      this.name = '';
      this.code = '';
      this.type = '';
      this.price_from = '';
      this.price_to = '';
      this.used_count = '';
      this.status = '';
      this.getCoupons();
    }
  }, {
    key: 'checkbox',
    value: function checkbox(id, check) {
      var index = this.checkboxes.indexOf(id);
      if (check == true) {
        if (index == '-1') {
          this.checkboxes.push(id);
        }
      } else {
        this.checkboxes.splice(index, 1);
      }
    }
  }, {
    key: 'checkAll',
    value: function checkAll() {
      if (this.selectall) {
        var vm = this;
        angular.forEach(this.coupons, function (coupon) {
          coupon.checked = 1;
          vm.checkboxes.push(coupon.id);
        });
      } else {
        angular.forEach(this.coupons, function (coupon) {
          coupon.checked = 0;
        });
        this.checkboxes = [];
      }
    }
  }]);
  return CouponController;
}();

// WEBPACK FOOTER //


exports.default = CouponController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/coupons/components/listing/controller.js
 **/